import { Avatar, Divider, IconButton, List, ListItem, ListItemAvatar, ListItemText, Typography } from '@mui/material'
import { Box } from '@mui/system'
import React, { useState } from 'react'
import Icon from '@mui/material/Icon';
import OAuthService from 'src/app/auth/services/oAuthService';
import oAuthServiceConfig from 'src/app/auth/services/oAuthService/oAuthServiceConfig';
import MoreAction from './MoreAction';
import * as Actions from './store/actions';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import Confirmation from './Confirmation';


const url = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.holidays}`;



export default function HolidaysList(props) {
  const [deleteDialog, setDeleteDialog] = useState(false)
  const [selectedItem, setSelectedItem] = useState({});
  const dispatch = useDispatch();
  const deleteHoliday = async (id) => {
    try {
      const response = await OAuthService.deleteData(url, id);
      props.loadData();
      toast.success('Holiday Deleted')
    } catch (error) {
      console.log(error.message);
    }
  }
  
  const handleClose = () => {
    setDeleteDialog(false)
  }

  const handleEdit = (item, setAnchorEl) => {
    dispatch(Actions.openEditEventDialog(item));
    setAnchorEl(null);
  }
  const handleDelete = (item) => {
    setDeleteDialog(false)
    deleteHoliday(item.id)
    setAnchorEl(null);
    setSelectedItem({})
  }
  const handleDeleteConfirmation = (item, setAnchorEl) => {
    setSelectedItem(item)
    setAnchorEl(null);
    setDeleteDialog(true);
  }
  const options = [
    {
      name: "Edit",
      onClick: handleEdit
    },
    {
      name: "Delete",
      onClick: handleDeleteConfirmation
    }
  ];
  const holidays = props.holiday?.filter(h => {
    console.log(h.title);
    const labels = props.titleOptions.map(to => to.label?.toLowerCase());
    return labels.includes(h.title.toLowerCase())
  })

  const events = props.holiday?.filter(h => {
    const labels = props.titleOptions.map(to => to.label?.toLowerCase());
    return !labels.includes(h.title.toLowerCase())
  })

  return (
    <>
      <Box sx={{ width: '360px' }}>
        <List sx={{ width: '100%', maxWidth: 360 }}>
          <ListItem>
            <ListItemAvatar>
              <Avatar>
                <Icon sx={{ color: "#fff" }}>today</Icon>
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary={
              <>
              Holidays
              {holidays.length> 0 ?
              <span className='holiday-count'>
                 {holidays.length} 
              </span>:""}
              </>
              } secondary="List of Holidays except weekly holidays." />
          </ListItem>
        </List>
        <List sx={{ width: '100%', maxWidth: 360 }}>
          {
            !holidays.length > 0 ? <ListItem>
              <ListItemText
                primary="No Holiday Found"
              />
            </ListItem> : 
            holidays.map(item => <>
              <ListItem
                key={item.id}
                alignItems="flex-start"
                secondaryAction={
                  <MoreAction id={item.id} item={item} options={options} />
                }
              >
                <ListItemText
                  primary={item.start.format('DD-MM-yyyy')}
                  secondary={item.title || '-'}
                />
              </ListItem>
              <Divider variant="inset" component="li" sx={{ marginLeft: 0 }} /></>)
          }
        </List>
        <List sx={{ width: '100%', maxWidth: 360 }}>
          <ListItem>
            <ListItemAvatar>
              <Avatar>
                <Icon sx={{ color: "#fff" }}>today</Icon>
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary={
              <>
              Events
              {events.length> 0 ?
              <span className='holiday-count'>
                 {events.length} 
              </span>:""}
              </>
              } secondary="List of events." />
          </ListItem>
        </List>
        <List sx={{ width: '100%', maxWidth: 360 }}>
          {
            !events.length > 0 ? <ListItem>
              <ListItemText
                primary="No Event Found"
              />
            </ListItem> : 
            events.map(item => <>
              <ListItem
                key={item.id}
                alignItems="flex-start"
                secondaryAction={
                  <MoreAction id={item.id} item={item} options={options} />
                }
              >
                <ListItemText
                  primary={item.start.format('DD-MM-yyyy')}
                  secondary={item.title || '-'}
                />
              </ListItem>
              <Divider variant="inset" component="li" sx={{ marginLeft: 0 }} /></>)
          }
        </List>
      </Box>
      <Confirmation open={deleteDialog} handleClose={handleClose} onYes={() => handleDelete(selectedItem)} title="Are you sure you want to delete this holiday?" message="This will delete this holiday permanently. You can not undo this action." />
    </>
  )
}
